import { AppContext } from "@lib/types";

export const URL_PARAMS = {
  CUSTOMER_ID: "customerId",
  CUSTOMER_LEAD_ID: "customerLeadId",
  TAB: "tab",
  TYPE: "type",
  PROVIDER_ID: "providerId",
  MANAGER_ID: "managerId",
  WALLET_ID: "walletId",
  INVOICE_ID: "invoiceId",
  PRODUCT_ID: "productId",
  NOTE_ID: "noteId",
  SETTING_ID: "settingId",
  AUDIT_LOG_ID: "auditLogId",
  CONFIG_ID: "configId",

  LEAD_ID: "leadId",
  CALL_ID: "callId",
  BLOCKCHAIN_PAYMENT_REQUEST_ID: "blockchainPaymentRequestId",
  BLOCKCHAIN_PAYMENT_ID: "blockchainPaymentId",
  CASH_PAYMENT_HISTORY_ID: "cashPaymentHistoryId",
  MARKET_PLACE_EMAIL_TEMPLATE_ID: "emailTemplateId",
  MARKET_PLACE_SUMMARY_ID: "summaryId",
  MARKET_PLACE_WHATSAPP_MESSAGE_ID: "whatsappMessageId",
  MARKET_PLACE_TRADER_ANALYSIS_ID: "traderAnalysisId",
  MARKET_PLACE_TRADE_ADVISE_ID: "tradeAdviseId",
  MARKET_PLACE_NOTE_VALIDATION_ID: "noteVAlidationId",
  MARKET_PLACE_FRAUD_DETECTION_ID: "fraudDetectionId",
};

export const DASHBOARD = "dashboard";
export const MANAGER = "systemUser";
export const WALLETS = "wallets";
export const WALLET_ACCOUNTS = "walletAccounts";
export const AI_PAYMENTS = "AIPayments";
export const SEND_BYTE_WALLETS = "sendByteWallets";
export const SEND_BYTE_WALLET_ACCOUNTS = "sendByteWalletAccounts";
export const INVOICE = "invoice";
export const BLOCKCHAIN_PAYMENT_REQUEST = "blockchainPaymentRequest";
export const BLOCKCHAIN_PAYMENTS = "blockchainPayments";
export const PAYMENT_HISTORY = "paymentHistory";
export const CASH_PAYMENT_HISTORY = "cashPaymentHistory";
export const PRODUCT = "products";
export const AUDIT_LOGS = "auditLogs";
export const NOTES = "notes";
export const SETTINGS = "settings";
export const NOTIFICATIONS = "notifications";
export const TELEGRAM_BOT = "telegramBot";
export const PAYMENT_TRANSACTION_CONFIG = "paymentTransactionConfig";
export const CUSTOMER = "customer";
export const CUSTOMER_LEAD = "customerLead";
export const PAYMENT_PROVIDER = "paymentProvider";
export const WALLET = "wallet";
export const AI_LOGS = "aiLogs";
export const TFT_SALES = "tftSales";
export const XAI_CALL_LOGS = "xaiCallLogs";
export const XAI_CALL_MODELS = "xaiCallModels";
export const CUSTOMER_VOIP_CONFIG = "customerVoipConfig";
export const MARKET_PLACE = "marketPlace";
export const MARKET_PLACE_EMAIL_TEMPLATE = "emailTemplate";
export const MARKET_PLACE_SUMMARY = "summary";
export const MARKET_PLACE_WHATSAPP_MESSAGE = "whatsappMessage";
export const MARKET_PLACE_TRADER_ANALYSIS = "traderAnalysis";
export const MARKET_PLACE_TRADE_ADVISE = "tradeAdvise";
export const MARKET_PLACE_NOTE_VALIDATION = "noteValidation";
export const MARKET_PLACE_FRAUD_DETECTION = "fraudDetection";

const ROUTES = {
  URL_PARAMS,

  AUTH: {
    LOGIN: "/auth/signin",
    TWO_FACTOR: "/auth/two-factor",
    FORGET_PASSWORD: "/auth/forget-password",
    RESET_PASSWORD: "/auth/reset-password",
  },

  ADMIN_MANAGEMENT: {
    DASHBOARD: `/management/${DASHBOARD}`,
  },

  ADMIN: {
    DASHBOARD: {
      CUSTOMER: `/admin/${DASHBOARD}/${AppContext.CUSTOMER}`,
      CUSTOMER_LEAD: `/admin/${DASHBOARD}/${AppContext.CUSTOMER_LEAD}`,
      PAYMENT_PROVIDER: `/admin/${DASHBOARD}/${AppContext.PAYMENT_PROVIDER}`,
      AI_PAYMENTS: `/admin/${DASHBOARD}/${AI_PAYMENTS}`,
      TFT_SALES: `/admin/${DASHBOARD}/${TFT_SALES}`,
    },

    PAYMENT_PROVIDER: {
      LIST: `/admin/${AppContext.PAYMENT_PROVIDER}/list`,
      DETAIL: `/admin/${AppContext.PAYMENT_PROVIDER}/detail/:${URL_PARAMS.PROVIDER_ID}`,
      DETAIL_TAB: `/admin/${AppContext.PAYMENT_PROVIDER}/detail/:${URL_PARAMS.PROVIDER_ID}/:${URL_PARAMS.TAB}`,

      MANAGER: {
        LIST: `/admin/${AppContext.PAYMENT_PROVIDER}/${MANAGER}/list`,
        DETAIL: `/admin/${AppContext.PAYMENT_PROVIDER}/${MANAGER}/:${URL_PARAMS.MANAGER_ID}`,
        DETAIL_TAB: `/admin/${AppContext.PAYMENT_PROVIDER}/${MANAGER}/:${URL_PARAMS.MANAGER_ID}/:${URL_PARAMS.TAB}`,
      },

      PAYMENT_HISTORY: {
        LIST: `/admin/${AppContext.PAYMENT_PROVIDER}/${PAYMENT_HISTORY}`,
      },

      PAYMENT_TRANSACTION_CONFIG: {
        LIST: `/admin/${AppContext.PAYMENT_PROVIDER}/${PAYMENT_TRANSACTION_CONFIG}`,
      },
    },

    CUSTOMER: {
      LIST: `/admin/${AppContext.CUSTOMER}/list`,
      DETAIL: `/admin/${AppContext.CUSTOMER}/detail/:${URL_PARAMS.CUSTOMER_ID}`,
      DETAIL_TAB: `/admin/${AppContext.CUSTOMER}/detail/:${URL_PARAMS.CUSTOMER_ID}/:${URL_PARAMS.TAB}`,

      MANAGER: {
        LIST: `/admin/${AppContext.CUSTOMER}/${MANAGER}/list`,
        DETAIL: `/admin/${AppContext.CUSTOMER}/${MANAGER}/:${URL_PARAMS.MANAGER_ID}`,
        DETAIL_TAB: `/admin/${AppContext.CUSTOMER}/${MANAGER}/:${URL_PARAMS.MANAGER_ID}/:${URL_PARAMS.TAB}`,
      },

      WALLET_ACCOUNTS: {
        LIST: `/admin/${AppContext.CUSTOMER}/${WALLET_ACCOUNTS}`,
        WALLET_ID: `/admin/${AppContext.CUSTOMER}/${WALLET_ACCOUNTS}/:${URL_PARAMS.WALLET_ID}`,

        LEAD: `/admin/${AppContext.CUSTOMER}/:${URL_PARAMS.CUSTOMER_ID}/${WALLET_ACCOUNTS}`,
        LEAD_WALLET_ID: `/admin/${AppContext.CUSTOMER}/:${URL_PARAMS.CUSTOMER_ID}/${WALLET_ACCOUNTS}/:${URL_PARAMS.WALLET_ID}`,

        CUSTOMER: `/admin/${AppContext.CUSTOMER}/:${URL_PARAMS.CUSTOMER_ID}/${WALLET_ACCOUNTS}`,
        CUSTOMER_WALLET_ID: `/admin/${AppContext.CUSTOMER}/:${URL_PARAMS.CUSTOMER_ID}/${WALLET_ACCOUNTS}/:${URL_PARAMS.WALLET_ID}`,
      },

      INVOICE: {
        LIST: `/admin/${AppContext.CUSTOMER}/${INVOICE}`,
      },

      BLOCKCHAIN_PAYMENT_REQUEST: {
        LIST: `/admin/${AppContext.CUSTOMER}/${BLOCKCHAIN_PAYMENT_REQUEST}`,
      },

      BLOCKCHAIN_PAYMENTS: {
        LIST: `/admin/${AppContext.CUSTOMER}/${BLOCKCHAIN_PAYMENTS}`,
        TYPE: `/admin/${AppContext.CUSTOMER}/${BLOCKCHAIN_PAYMENTS}/:${URL_PARAMS.TYPE}`,
      },

      CASH_PAYMENT_HISTORY: {
        LIST: `/admin/${AppContext.CUSTOMER}/${CASH_PAYMENT_HISTORY}`,
      },

      PAYMENT_HISTORY: {
        LIST: `/admin/${AppContext.CUSTOMER}/${PAYMENT_HISTORY}`,
      },
    },

    CUSTOMER_LEAD: {
      LIST: `/admin/${AppContext.CUSTOMER_LEAD}/list`,
      DETAIL: `/admin/${AppContext.CUSTOMER_LEAD}/detail/:${URL_PARAMS.CUSTOMER_LEAD_ID}`,
      DETAIL_TAB: `/admin/${AppContext.CUSTOMER_LEAD}/detail/:${URL_PARAMS.CUSTOMER_LEAD_ID}/:${URL_PARAMS.TAB}`,

      WALLET_ACCOUNTS: {
        LIST: `/admin/${AppContext.CUSTOMER_LEAD}/${WALLET_ACCOUNTS}`,
        WALLET_ID: `/admin/${AppContext.CUSTOMER_LEAD}/${WALLET_ACCOUNTS}/:${URL_PARAMS.WALLET_ID}`,
        LEAD: `/admin/${AppContext.CUSTOMER_LEAD}/:${URL_PARAMS.CUSTOMER_LEAD_ID}/${WALLET_ACCOUNTS}`,
        LEAD_WALLET_ID: `/admin/${AppContext.CUSTOMER_LEAD}/:${URL_PARAMS.CUSTOMER_LEAD_ID}/${WALLET_ACCOUNTS}/:${URL_PARAMS.WALLET_ID}`,
      },

      BLOCKCHAIN_PAYMENTS: {
        LIST: `/admin/${AppContext.CUSTOMER_LEAD}/${BLOCKCHAIN_PAYMENTS}`,
        TYPE: `/admin/${AppContext.CUSTOMER_LEAD}/${BLOCKCHAIN_PAYMENTS}/:${URL_PARAMS.TYPE}`,
      },

      BLOCKCHAIN_PAYMENT_REQUESTS: {
        LIST: `/admin/${AppContext.CUSTOMER_LEAD}/${BLOCKCHAIN_PAYMENT_REQUEST}`,
      },
    },

    TFT_SALES: {
      LEAD_LIST: `/tft-sales/leads`,
      LEAD_DETAIL: `/tft-sales/leads/:${URL_PARAMS.LEAD_ID}`,

      CALL_LIST: `/tft-sales/calls`,
      CALL_DETAIL: `/tft-sales/calls/:${URL_PARAMS.CALL_ID}`,
    },

    XAI_CALL_LOGS: {
      LIST: `/admin/${XAI_CALL_LOGS}/list`,
    },

    XAI_CALL_MODELS: {
      LIST: `/admin/${XAI_CALL_MODELS}/list`,
    },

    CUSTOMER_VOIP_CONFIG: {
      LIST: `/admin/${CUSTOMER_VOIP_CONFIG}/list`,
    },

    MARKET_PLACE: {
      EMAIL_TEMPLATE: {
        LIST: `/admin/${MARKET_PLACE}/${MARKET_PLACE_EMAIL_TEMPLATE}`,
        DETAIL: `/admin/${MARKET_PLACE}/${MARKET_PLACE_EMAIL_TEMPLATE}/:${URL_PARAMS.MARKET_PLACE_EMAIL_TEMPLATE_ID}`,
      },
      SUMMARY: {
        LIST: `/admin/${MARKET_PLACE}/${MARKET_PLACE_SUMMARY}`,
        DETAIL: `/admin/${MARKET_PLACE}/${MARKET_PLACE_SUMMARY}/:${URL_PARAMS.MARKET_PLACE_SUMMARY_ID}`,
      },
      WHATSAPP_MESSAGE: {
        LIST: `/admin/${MARKET_PLACE}/${MARKET_PLACE_WHATSAPP_MESSAGE}`,
        DETAIL: `/admin/${MARKET_PLACE}/${MARKET_PLACE_WHATSAPP_MESSAGE}/:${URL_PARAMS.MARKET_PLACE_WHATSAPP_MESSAGE_ID}`,
      },
      TRADER_ANALYSIS: {
        LIST: `/admin/${MARKET_PLACE}/${MARKET_PLACE_TRADER_ANALYSIS}`,
        DETAIL: `/admin/${MARKET_PLACE}/${MARKET_PLACE_TRADER_ANALYSIS}/:${URL_PARAMS.MARKET_PLACE_TRADER_ANALYSIS_ID}`,
      },
      TRADE_ADVISE: {
        LIST: `/admin/${MARKET_PLACE}/${MARKET_PLACE_TRADE_ADVISE}`,
        DETAIL: `/admin/${MARKET_PLACE}/${MARKET_PLACE_TRADE_ADVISE}/:${URL_PARAMS.MARKET_PLACE_TRADE_ADVISE_ID}`,
      },
      NOTE_VALIDATION: {
        LIST: `/admin/${MARKET_PLACE}/${MARKET_PLACE_NOTE_VALIDATION}`,
      },
      FRAUD_DETECTION: {
        LIST: `/admin/${MARKET_PLACE}/${MARKET_PLACE_FRAUD_DETECTION}`,
      },
    },

    SETTINGS: {
      LIST: `/admin/${SETTINGS}`,
      DETAIL_TAB: `/admin/${SETTINGS}/:${URL_PARAMS.TAB}`,
      TWO_FACTOR_AUTH_CONFIG: {
        LIST: `/admin/${SETTINGS}/twoFactorAuthConfig`,
      },

      APP_RESTRICTION_CONFIG: {
        LIST: `/admin/${SETTINGS}/appRestrictionConfig`,
      },

      BILLING_CONFIGS: {
        LIST: `/admin/${SETTINGS}/billingConfigs`,
      },
    },

    TELEGRAM_BOT: {
      TELEGRAM_BOT_CONFIG: {
        LIST: `/admin/${TELEGRAM_BOT}/telegramBotConfig`,
        DETAIL: `/admin/${TELEGRAM_BOT}/telegramBotConfig/:${URL_PARAMS.CONFIG_ID}`,
        CANVAS_TAB: `/admin/${TELEGRAM_BOT}/telegramBotConfig/:${URL_PARAMS.CONFIG_ID}/canvas`,
        LIST_TAB: `/admin/${TELEGRAM_BOT}/telegramBotConfig/:${URL_PARAMS.CONFIG_ID}/list`,
      },

      TELEGRAM_BOT_USERS: {
        LIST: `/admin/${TELEGRAM_BOT}/telegramBotUsers`,
      },

      TELEGRAM_BOT_CONFIGS: {
        LIST: `/admin/${TELEGRAM_BOT}/telegramBotConfigs`,
        DETAIL: `/admin/${TELEGRAM_BOT}/telegramBotConfigs/:${URL_PARAMS.CONFIG_ID}`,
        CANVAS_TAB: `/admin/${TELEGRAM_BOT}/telegramBotConfigs/:${URL_PARAMS.CONFIG_ID}/canvas`,
        LIST_TAB: `/admin/${TELEGRAM_BOT}/telegramBotConfigs/:${URL_PARAMS.CONFIG_ID}/list`,
      },
    },
  },

  CUSTOMER: {
    DASHBOARD: `/customer/dashboard`,
    SETTINGS: `/customer/settings`,

    INVOICE: {
      LIST: `/customer/${INVOICE}`,
    },

    PAYMENT_HISTORY: {
      LIST: `/customer/${PAYMENT_HISTORY}`,
    },

    BLOCKCHAIN_PAYMENT_REQUEST: {
      LIST: `/customer/${BLOCKCHAIN_PAYMENT_REQUEST}`,
    },

    BLOCKCHAIN_PAYMENTS: {
      LIST: `/customer/${BLOCKCHAIN_PAYMENTS}`,
      TYPE: `/customer/${BLOCKCHAIN_PAYMENTS}/:${URL_PARAMS.TYPE}`,
    },

    CASH_PAYMENT_HISTORY: {
      LIST: `/customer/${CASH_PAYMENT_HISTORY}`,
    },
  },

  CUSTOMER_LEAD: {
    LIST: `/${AppContext.CUSTOMER_LEAD}/list`,
    DETAIL: `/${AppContext.CUSTOMER_LEAD}/detail/:${URL_PARAMS.CUSTOMER_LEAD_ID}`,
    DETAIL_TAB: `/${AppContext.CUSTOMER_LEAD}/detail/:${URL_PARAMS.CUSTOMER_LEAD_ID}/:${URL_PARAMS.TAB}`,

    BLOCKCHAIN_PAYMENT_REQUESTS: {
      LIST: `/${AppContext.CUSTOMER_LEAD}/${BLOCKCHAIN_PAYMENT_REQUEST}`,
    },
    BLOCKCHAIN_PAYMENTS: {
      LIST: `/${AppContext.CUSTOMER_LEAD}/${BLOCKCHAIN_PAYMENTS}`,
      TYPE: `/${AppContext.CUSTOMER_LEAD}/${BLOCKCHAIN_PAYMENTS}/:${URL_PARAMS.TYPE}`,
    },
  },

  PROVIDER: {
    DASHBOARD: `/provider/dashboard`,

    SETTINGS: `/provider/settings`,

    PAYMENT_HISTORY: {
      LIST: `/provider/${PAYMENT_HISTORY}`,
    },

    PAYMENT_TRANSACTION_CONFIG: {
      LIST: `/provider/${PAYMENT_TRANSACTION_CONFIG}`,
    },
  },

  MANAGER: {
    LIST: `/${MANAGER}/list`,
    DETAIL: `/${MANAGER}/detail/:${URL_PARAMS.MANAGER_ID}`,
    DETAIL_TAB: `/${MANAGER}/detail/:${URL_PARAMS.MANAGER_ID}/:${URL_PARAMS.TAB}`,
  },

  WALLET_ACCOUNTS: {
    LIST: `/${WALLET_ACCOUNTS}/list`,
    WALLET_ID: `/${WALLET_ACCOUNTS}/wallet/:${URL_PARAMS.WALLET_ID}`,
    CUSTOMER_ID: `/${WALLET_ACCOUNTS}/customer/:${URL_PARAMS.CUSTOMER_ID}`,
    CUSTOMER_WALLET_ID: `/${WALLET_ACCOUNTS}/customer/:${URL_PARAMS.CUSTOMER_ID}/wallet/:${URL_PARAMS.WALLET_ID}`,
    LEAD: `/${WALLET_ACCOUNTS}/customerUser/:${URL_PARAMS.CUSTOMER_LEAD_ID}`,
    LEAD_WALLET_ID: `/${WALLET_ACCOUNTS}/customerUser/:${URL_PARAMS.CUSTOMER_LEAD_ID}/wallet/:${URL_PARAMS.WALLET_ID}`,
  },

  AI_PAYMENTS: {
    WALLET_LIST: `/${AI_PAYMENTS}/wallets`,
    WALLET_ID: `/${AI_PAYMENTS}/wallets/:${URL_PARAMS.WALLET_ID}`,
    CUSTOMER_ID: `/${AI_PAYMENTS}/customers/:${URL_PARAMS.CUSTOMER_ID}`,
    CUSTOMER_WALLET_ID: `/${AI_PAYMENTS}/customers/:${URL_PARAMS.CUSTOMER_ID}/wallets/:${URL_PARAMS.WALLET_ID}`,

    BLOCKCHAIN_PAYMENT_REQUESTS: `/${AI_PAYMENTS}/${BLOCKCHAIN_PAYMENT_REQUEST}`,
    BLOCKCHAIN_PAYMENT_REQUEST_ID: `/${AI_PAYMENTS}/${BLOCKCHAIN_PAYMENT_REQUEST}/:${URL_PARAMS.BLOCKCHAIN_PAYMENT_REQUEST_ID}`,

    BLOCKCHAIN_PAYMENTS: `/${AI_PAYMENTS}/${BLOCKCHAIN_PAYMENTS}`,
    BLOCKCHAIN_PAYMENT_ID: `/${AI_PAYMENTS}/${BLOCKCHAIN_PAYMENTS}/:${URL_PARAMS.BLOCKCHAIN_PAYMENT_ID}`,
  },

  SEND_BYTE_WALLETS: {
    LIST: `/${SEND_BYTE_WALLETS}/list`,
  },

  SEND_BYTE_WALLET_ACCOUNTS: {
    LIST: `/${SEND_BYTE_WALLET_ACCOUNTS}/list`,
    WALLET_ID: `/${SEND_BYTE_WALLET_ACCOUNTS}/${WALLET}/:${URL_PARAMS.WALLET_ID}`,
    CUSTOMER_ID: `/${SEND_BYTE_WALLET_ACCOUNTS}/${CUSTOMER}/:${URL_PARAMS.CUSTOMER_ID}`,
    CUSTOMER_WALLET_ID: `/${SEND_BYTE_WALLET_ACCOUNTS}/${CUSTOMER}/:${URL_PARAMS.CUSTOMER_ID}/${WALLET}/:${URL_PARAMS.WALLET_ID}`,
    LEAD: `/${SEND_BYTE_WALLET_ACCOUNTS}/${CUSTOMER_LEAD}/:${URL_PARAMS.CUSTOMER_LEAD_ID}`,
    LEAD_WALLET_ID: `/${SEND_BYTE_WALLET_ACCOUNTS}/${CUSTOMER_LEAD}/:${URL_PARAMS.CUSTOMER_LEAD_ID}/${WALLET}/:${URL_PARAMS.WALLET_ID}`,
  },

  AI_LOGS: {
    LIST: `/${AI_LOGS}`,
  },

  INVOICE: {
    LIST: `/${INVOICE}`,
    DETAIL: `/${INVOICE}/:${URL_PARAMS.INVOICE_ID}`,
  },

  BLOCKCHAIN_PAYMENTS: {
    LIST: `/${BLOCKCHAIN_PAYMENTS}`,
    TYPE: `/${BLOCKCHAIN_PAYMENTS}/:${URL_PARAMS.TYPE}`,
  },

  PAYMENT_HISTORY: {
    LIST: `/${PAYMENT_HISTORY}`,
  },

  CASH_PAYMENT_HISTORY: {
    LIST: `/${CASH_PAYMENT_HISTORY}`,
  },

  BLOCKCHAIN_PAYMENT_REQUEST: {
    LIST: `/${BLOCKCHAIN_PAYMENT_REQUEST}`,
  },

  PRODUCT: {
    LIST: `/${PRODUCT}`,
  },

  MONITORING: {
    AUDIT_LOGS: {
      LIST: `/${AUDIT_LOGS}`,
      DETAIL: `/${AUDIT_LOGS}/:${URL_PARAMS.AUDIT_LOG_ID}`,
    },
  },

  NOTES: {
    LIST: `/${NOTES}`,
  },

  NOTIFICATIONS: {
    LIST: `/${NOTIFICATIONS}`,
  },

  MY_PROFILE: {
    LIST: `/my-profile`,
    DETAIL_TAB: `/my-profile/:${URL_PARAMS.TAB}`,
  },
};

export default ROUTES;
